export let READONLY_FIELD_TYPES = /*#__PURE__*/function (READONLY_FIELD_TYPES) {
  READONLY_FIELD_TYPES["HEADER"] = "HEADER";
  READONLY_FIELD_TYPES["RICH_TEXT"] = "RICH_TEXT";
  READONLY_FIELD_TYPES["SUBMIT_BUTTON"] = "SUBMIT_BUTTON";
  READONLY_FIELD_TYPES["ECOM_CONTACT_DETAILS"] = "ECOM_CONTACT_DETAILS";
  READONLY_FIELD_TYPES["ECOM_SHIPPING_DETAILS"] = "ECOM_SHIPPING_DETAILS";
  return READONLY_FIELD_TYPES;
}({});
//# sourceMappingURL=readonly-field-types.js.map